import React from 'react';
import { Card, CardContent } from '../ui/card';
import { Badge } from '../ui/badge';
import { ChevronDown, X } from 'lucide-react';

const PlaceholderDepartmentCard = ({
  dept,
  isSelected,
  isCollapsed,
  editDepartmentMode,
  onSelect,
  onToggleCollapse,
  onToggleVisibility
}) => {
  const Icon = dept.icon;

  return (
    <div className="relative">
      {/* Edit Mode Visibility Toggle */}
      {editDepartmentMode && (
        <div className="absolute -top-2 -right-2 z-10">
          <button
            onClick={(e) => { e.stopPropagation(); onToggleVisibility(dept.id); }}
            className="h-5 w-5 rounded-full bg-red-500 hover:bg-red-600 text-white flex items-center justify-center shadow-lg"
            title="Hide Department"
          >
            <X className="h-3 w-3" />
          </button>
        </div>
      )}
      <button
        onClick={() => !editDepartmentMode && onSelect(dept.id)}
        className={`w-full text-left transition-all duration-200 ${isSelected ? 'scale-[1.02]' : 'hover:scale-[1.01]'}`}
      >
        <Card 
          className={`h-full border ${isSelected ? 'border-amber-500' : 'border-dashed border-muted-foreground/30'} cursor-pointer hover:border-amber-400/50 bg-muted/20`}
          style={{
            boxShadow: isSelected 
              ? '0 0 15px rgba(245, 158, 11, 0.25), 0 0 30px rgba(245, 158, 11, 0.1)'
              : 'none'
          }}
        >
          <CardContent className="p-2">
            {/* Header with collapse toggle */}
            <div 
              className="flex items-center gap-1.5 cursor-pointer"
              onClick={(e) => { e.stopPropagation(); onToggleCollapse(dept.id); }}
            >
              <div className={`h-5 w-5 rounded ${isSelected ? 'bg-amber-500' : 'bg-muted'} flex items-center justify-center`}>
                <Icon className={`h-3 w-3 ${isSelected ? 'text-white' : 'text-muted-foreground'}`} />
              </div>
              <span className="text-sm opacity-70">{dept.emoji}</span>
              <ChevronDown className={`h-2.5 w-2.5 ml-auto text-muted-foreground transition-transform ${isCollapsed ? '-rotate-90' : ''}`} />
            </div>
            <h3 className="font-medium text-[10px] truncate text-muted-foreground mt-0.5">
              {dept.name.split(' ')[0]}
            </h3>
            
            {/* Collapsible Content */}
            {!isCollapsed && (
              <div className="mt-1">
                <Badge variant="outline" className="text-[8px] bg-muted/50 h-4 px-1">
                  Coming Soon
                </Badge>
              </div>
            )}
          </CardContent>
        </Card>
      </button>
    </div>
  );
};

export default PlaceholderDepartmentCard;